import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";
import { Link } from "react-router-dom";
import { InfinitySpin } from "react-loader-spinner";
import { MultiRootEditor, Bold, Essentials, Italic, Paragraph, Underline, Strikethrough, List, BlockQuote, Code } from "ckeditor5";
import { useMultiRootEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
const SurveyProgramming = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isDropdownVisible, setDropdownVisible] = useState(true);
  const [isDropdownVisible2, setDropdownVisible2] = useState(true);
  const [isDropdownVisible3, setDropdownVisible3] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const [showInstructions, setShowInstructions] = useState(false);
  const [showDescription, setShowDescription] = useState(false);
  const [showProgramInstructions, setShowProgramInstructions] = useState(false);
  const [answers, setAnswers] = useState([{ id: 1, answer: "" }]);
  const [columns, setColumns] = useState([{ id: 1, column: "" }]);
  const [isLoading, setIsLoading] = useState(false);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isVisible2, setIsVisible2] = useState(false);
  const [showRowCode, setShowRowCode] = useState(false);
  // const [rows, setRows] = useState([]);

  const defaultRoots = ["intro", "content1", "content2", "content3", "content4", "content5"];
  const [editorRoots, setEditorRoots] = useState(defaultRoots);
  const [moreFieldsRoots, setMoreFieldsRoots] = useState([]);
  const [anotherFieldsRoots, setAnotherFieldsRoots] = useState([]);
  const toggleVisibility = () => {
    setIsVisible((prevState) => !prevState);
  };
  const toggleVisibility2 = () => {
    setIsVisible2((prevState) => !prevState);
  };

  const toggleContentVisibility = () => {
    setIsContentVisible((prevState) => !prevState);
  };
  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };
  const toggleDropdown = () => {
    setDropdownVisible((prev) => !prev);
  };
  const toggleDropdown2 = () => {
    setDropdownVisible2((prev) => !prev);
  };
  const toggleDropdown3 = () => {
    setDropdownVisible3((prev) => !prev);
  };
  const toggleContent = () => {
    setIsOpen(!isOpen);

  };

  const handleCardClick = (index) => {
    setActiveIndex(index);
  };

  const toggleRowCodeVisibility = () => {
    setShowRowCode((prevState) => !prevState);
  };

  const getCardStyle = (index) => ({
    cursor: "pointer",
    backgroundColor: activeIndex === index ? "#e6ffe6" : "transparent",
    border: activeIndex === index ? "none" : "1px solid #ddd",
  });

  const handleToggleInstructions = () => {
    setShowInstructions(!showInstructions);
  };

  const handleToggleDescription = () => {
    setShowDescription(!showDescription);
  };

  const handleToggleProgramInstructions = () => {
    setShowProgramInstructions(!showProgramInstructions);
  };

  const handleCheckboxChange = () => setIsChecked(!isChecked);
  // const addAnswerRow = () => {
  //   const newId = answers.length ? answers[answers.length - 1].id + 1 : 1;
  //   setAnswers([...answers, { id: newId, answer: "" }]);
  // };

  // // Handle answer input change
  // const handleInputChange = (id, value) => {
  //   setAnswers((prevAnswers) =>
  //     prevAnswers.map((answer) =>
  //       answer.id === id ? { ...answer, answer: value } : answer
  //     )
  //   );
  // };

  // // Delete a specific answer row
  // const deleteAnswerRow = (id) => {
  //   if (id === 1) {
  //     // Prevent deletion of the first row
  //     return;
  //   }

  //   // Filter rows where row.id is not equal to the given id
  //   const updatedRows = answers.filter((answer) => answer.id !== id);
  //   setAnswers(updatedRows);
  // };
  // // Add a new column
  // const addAnswerColumn = () => {
  //   const newId = columns.length ? columns[columns.length - 1].id + 1 : 1;
  //   setColumns([...columns, { id: newId, column: "" }]);
  // };

  // // Handle column input change
  // const handleColumnChange = (id, value) => {
  //   setColumns((prevColumns) =>
  //     prevColumns.map((col) =>
  //       col.id === id ? { ...col, column: value } : col
  //     )
  //   );
  // };

  // Delete a specific column
  // const deleteAnswerColumn = (id) => {
  //   if (id === 1) {
  //     // Prevent deletion of the first column
  //     return;
  //   }



  // Dummy Question Answers
  const dummyquestions = [
    { id: 1, text: "Q1" },
    { id: 2, text: "Q2" },
    { id: 3, text: "Q3" }
  ];

  const dummyanswers = [
    { id: 1, text: "A1" },
    { id: 2, text: "A2" },
    { id: 3, text: "A3" },
    { id: 4, text: "A4" }
  ];

  // Dummy answer end

  const [showAllLanguages, setShowAllLanguages] = useState(false);
  // List of languages
  const languages = [
    { id: "flexCheckEnglish", label: "English" },
    { id: "flexCheckHindi", label: "Hindi" },
    { id: "flexCheckGerman", label: "German" },
    { id: "flexCheckKannada", label: "Kannada" },
    { id: "flexCheckFrench", label: "French" },
    { id: "flexCheckItalian", label: "Italian" },
    { id: "flexCheckMandarin", label: "Mandarin" },
    { id: "flexCheckSpanish", label: "Spanish" },
    { id: "flexCheckArabic", label: "Arabic" },
    { id: "flexCheckRussian", label: "Russian" },
    { id: "flexCheckPortuguese", label: "Portuguese" },
    { id: "flexCheckJapanese", label: "Japanese" },
    { id: "flexCheckKorean", label: "Korean" },
    { id: "flexCheckPolish", label: "Polish" },
    { id: "flexCheckSwedish", label: "Swedish" },
    { id: "flexCheckDanish", label: "Danish" },
    { id: "flexCheckNorwegian", label: "Norwegian" },
  ];

  // Number of languages to show by default
  const defaultLanguagesToShow = isOpen ? 4 : 2;;

  // Function to toggle the visibility of all languages
  const toggleShowAllLanguages = () => {
    setShowAllLanguages(!showAllLanguages);
  };



  const [logicString, setLogicString] = useState(''); // Initialize blank logic string
  const [logicConditions, setLogicConditions] = useState([
    { question: "", is: "=", answer: "", nestlogic: "" } // Initialize without nesting logic
  ]);

  // Function to handle adding new logic
  const addLogicCondition = () => {
    setLogicConditions([...logicConditions, { question: "", is: "=", answer: "", nestlogic: "||" }]);
  };

  // Function to handle changes in the form inputs
  const handleChange = (index, field, value) => {
    const newLogicConditions = [...logicConditions];
    newLogicConditions[index][field] = value;
    setLogicConditions(newLogicConditions);
  };

  // Function to update the logic string for the textarea
  const updateLogicString = () => {
    if (logicConditions.length === 0 || !logicConditions[0].question) {
      setLogicString(''); // Keep it empty if no conditions are present
      return;
    }

    const logicText = logicConditions.map((logic, index) => {
      const question = logic.question ? `${logic.question}` : "Question: Not selected";
      const isCondition = logic.is ? ` ${logic.is} ` : "";
      const answer = logic.answer ? `${logic.answer}` : "Answer: Not selected";

      const conditionString = `${question}${isCondition}${answer}`;

      // Add nesting logic if this is not the last condition
      if (index < logicConditions.length - 1) {
        const nestLogic = logic.nestlogic ? ` ${logic.nestlogic} ` : "";
        return `${conditionString}\n${nestLogic}`;
      }

      return conditionString;
    }).join("\n");

    setLogicString(logicText);
  };

  // Use effect to update the logic string whenever logicConditions change
  useEffect(() => {
    updateLogicString();
  }, [logicConditions]);

  // const addRow = () => {
  // setRows([...rows, {}]); // Add a new object to the array (each object represents a row)
  // };

  // // Function to remove a row (based on the index)
  // const removeRow = (index) => {
  //   setRows(rows.filter((_, i) => i !== index));
  // };

  //   // Filter out the column where col.id is not equal to the given id
  //   const updatedColumns = columns.filter((col) => col.id !== id);
  //   setColumns(updatedColumns);
  // };
  const handleAddNewQuestionClick = () => {
    setIsLoading(true);

    // Hide spinner after 1 millisecond
    setTimeout(() => {
      setIsLoading(false);
      window.location.reload(); // Reload the page
    }, 3000);
  };

  const editorProps = {
    editor: MultiRootEditor,
    data: editorRoots.reduce(
      (data, root, index) => ({
        ...data,
        [root]: `<p></p>`,
      }),
      {}
    ),
    config: {
      plugins: [Essentials, Bold, Italic, Underline, Strikethrough, List, BlockQuote, Code, Paragraph],
      toolbar: {
        items: ["bold", "italic", "underline", "strikethrough", "bulletedList", "numberedList", "blockQuote", "code"],
      },
      placeholder: "Type your answer here...",
    },
  };

  const { toolbarElement, editableElements, editor } = useMultiRootEditor(editorProps);

  const addRows = () => {
    const newRoot = `moreField${moreFieldsRoots.length + 1}`;
    editor.addRoot(newRoot, { data: "<p></p>" });
    setMoreFieldsRoots([...moreFieldsRoots, newRoot]);
  };

  const addColumns = () => {
    const newRoot = `anotherField${anotherFieldsRoots.length + 1}`;
    editor.addRoot(newRoot, { data: "<p></p>" });
    setAnotherFieldsRoots([...anotherFieldsRoots, newRoot]);
  };

  const renderRows = () => {
    return moreFieldsRoots.map((root, index) => (
      <div key={index} className="d-flex align-items-center mt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
          />
        </svg>
        <div className="form-group col-lg-4 ms-2">{editableElements[editorRoots.length + index]}</div>
        <div className="col-lg-1 ms-2">
          <button
            type="button"
            className="btn btn-light p-0 border-0"
            style={{
              backgroundColor: "#FFE3E6",
              width: "33px",
            }}
            onClick={() => deleteField(root)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-trash3-fill" viewBox="0 0 16 16">
              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
            </svg>
          </button>
        </div>
      </div>
    ));
  };

  const renderColumns = () => {
    return anotherFieldsRoots.map((root, index) => (
      <div key={index} className="d-flex align-items-center mt-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
          />
        </svg>
        <div className="form-group col-lg-4 ms-2">{editableElements[editorRoots.length + moreFieldsRoots.length + index]}</div>
        <div className="col-lg-1 ms-2">
          <button
            type="button"
            className="btn btn-light p-0 border-0"
            style={{
              backgroundColor: "#FFE3E6",
              width: "33px",
            }}
            onClick={() => deleteField(root)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="red" className="bi bi-trash3-fill" viewBox="0 0 16 16">
              <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
            </svg>
          </button>
        </div>
      </div>
    ));
  };

  const deleteField = (rootName) => {
    editor.detachRoot(rootName);
    if (moreFieldsRoots.includes(rootName)) {
      setMoreFieldsRoots(moreFieldsRoots.filter((root) => root !== rootName));
    } else if (anotherFieldsRoots.includes(rootName)) {
      setAnotherFieldsRoots(anotherFieldsRoots.filter((root) => root !== rootName));
    }
  };

  return (
    <div>
      {/* Sidebar */}
      <Asidebar isActivated={isActivated} />

      {/* Main content wrapper */}
      <div id="wrapper" className={fullwidthwrapper}>
        {/* Navbar */}
        <Header onclick={handleToggle} />

        {/* Sidebar content as in the second image */}
        <div className="container-fluid py-4">
          <div className="row">
            <div className="col-lg-3">
              <div className="card border-light-subtle">
                <div className="p-4">
                  <div className="sidebar-section">
                    {/* <h7 className="text-secondary fw-bold ms-3">
                      Question statement
                    </h7>
                    <hr
                      className="my-3 "
                      style={{
                        borderTop: "3px solid #6c757d",
                      }}
                    /> */}
                    <div className="common_form p-2 mb-9">
                      <label className=" py-2 bg-heading text-center fw-bold ">Question Statement</label>
                    </div>
                    <ul className="list-group list-group-flush">
                      <li className="list-group-item d-flex align-items-center" style={{ borderBottom: "none" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                          />
                        </svg>
                        <label>Device</label>
                      </li>

                      <li className="list-group-item d-flex align-items-center" style={{ borderBottom: "none" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                          />
                        </svg>

                        <div className="me-2">
                          {/* <FontAwesomeIcon
                            icon={faChevronDown}
                            style={{
                              fontSize: "12px",
                            }}
                            className="mb-3"
                          /> */}
                          {/* <i className="bi bi-caret-down-square "></i>
                           */}
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
                            <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
                              <rect width="18" height="18" x="3" y="3" rx="2" />
                              <path d="m16 10l-4 4l-4-4" />
                            </g>
                          </svg>
                        </div>
                        <label>Age</label>
                      </li>

                      <li className="list-group-item d-flex align-items-center justify-content-between" style={{ borderBottom: "2px solid lightgray" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <div className="col-lg-2 ">

                          <svg xmlns="http://www.w3.org/2000/svg" width="2.5em" height="1.5em" viewBox="0 0 16 16">
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                            />
                          </svg>
                        </div>
                        <div className="col-lg-8 ">
                          <input type="radio" className="form-check-input me-2" checked={true} />
                          <label>What is your gender ?</label>
                        </div>
                        <div className="col-lg-2 dropdown">

                          <i className="bi bi-three-dots-vertical" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"></i>
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                Delete Question
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Copy Question
                              </a>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <li className="list-group-item d-flex align-items-center" style={{ borderBottom: "none" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                          />
                        </svg>
                        <label>Employment Status</label>
                      </li>
                      <li className="list-group-item d-flex align-items-center" style={{ borderBottom: "none" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                          />
                        </svg>
                        <label>Work Experience</label>
                      </li>
                      <li className="list-group-item d-flex align-items-center" style={{ borderBottom: "2px solid lightgray" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                          />
                        </svg>
                        <label>Company Size</label>
                      </li>
                      <li className="list-group-item d-flex align-items-center" style={{ borderBottom: "none" }}>
                        {/* <FontAwesomeIcon
                          icon={faGripVertical}
                          className="me-2 text-secondary"
                        /> */}
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                          <path
                            fill="currentColor"
                            fill-rule="evenodd"
                            d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                          />
                        </svg>
                        <label>Company revenue</label>
                      </li>
                    </ul>
                    <div className="mt-3">
                      <button className="btn btn-success w-100">Page break</button>
                      {/* <Link to="/survey-programming">
                        <button className="btn btn-success w-100 mt-2">
                          + Add new question
                        </button>
                      </Link> */}
                      {isLoading && (
                        <div
                          style={{
                            position: "fixed",
                            top: "50%",
                            left: "60%",
                            transform: "translate(-50%, -50%)",
                            zIndex: 9999, // Ensure it appears above other content
                          }}
                        >
                          <InfinitySpin visible={true} width="200" color="#4fa94d" ariaLabel="infinity-spin-loading" />
                        </div>
                      )}

                      {/* Link and Button */}
                      <Link to="/survey-programming" onClick={handleAddNewQuestionClick}>
                        <button className="btn btn-success w-100 mt-2">+ Add new question</button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-9">
              {/* <div className="section-2 ">
                <div className="text-secondary fw-bold mb-2">
                  Question Properties
                </div>
                <div
                  className={`question-properties d-flex justify-content-start align-items-center ${isOpen ? "expanded" : ""
                    }`}
                  style={{ flexGrow: 1, border: "none" }}
                >
                  <div className="property-item text-secondary">
                    {/* Visibility condition ▼ 
                    <div>
                      <label className="me-2 text-secondary mb-0  fs-11 ">
                        Visibility condition
                      </label>
                      <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown}
                        role="button"
                        aria-expanded={isDropdownVisible}
                        style={{ cursor: "pointer" }} // Ensures pointer cursor on hover
                      ></i>
                    </div>
                    {isDropdownVisible && isOpen && (
                      <div
                        style={{ zIndex: 2000 }} // Ensures dropdown is above other content
                      >
                        <div
                          className="card  pe-1 ps-1 fs-11 mt-2"
                          style={{ border: "none", backgroundColor: "#e6ffe6" }}
                        >
                          <strong>Active Logic:</strong>
                          (q1.val=r1 & q2.val=r5)
                        </div>
                        <div className="mt-2">
                          <button className="btn btn-success w-100  mx-0 ">
                            Logic Setup
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="property-item text-secondary ms-2 me-2 pe-4 ">
                    <div>
                      <label className="me-2 text-secondary mb-0 fs-11">
                        Language
                      </label>
                      <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown2}
                        role="button"
                        aria-expanded={isDropdownVisible2}
                        style={{ cursor: "pointer" }} // Ensures pointer cursor on hover
                      ></i>
                    </div>
                    {isDropdownVisible2 && isOpen && (
                      <div
                        className="mt-2"
                        
                        style={{ zIndex: 2000, minWidth: "140px" }}
                      >
                        <div className="row g-1">
                          <div className="col-6">
                            <div>
                              <input
                                className="form-check-input me-1"
                                type="checkbox"
                                id="flexCheckEnglish"
                                style={{ transform: "scale(1)" }}
                              />
                              <label
                                htmlFor="flexCheckEnglish"
                                className="text-secondary fs-12"
                              >
                                English
                              </label>
                            </div>
                            <div>
                              <input
                                className="form-check-input me-1"
                                type="checkbox"
                                id="flexCheckGerman"
                                style={{ transform: "scale(1)" }}
                              />
                              <label
                                htmlFor="flexCheckGerman"
                                className="text-secondary fs-12"
                              >
                                German
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div>
                              <input
                                className="form-check-input me-1"
                                type="checkbox"
                                id="flexCheckHindi"
                                style={{ transform: "scale(1)" }}
                              />
                              <label
                                htmlFor="flexCheckHindi"
                                className="text-secondary fs-12"
                              >
                                Hindi
                              </label>
                            </div>
                            <div>
                              <input
                                className="form-check-input me-1"
                                type="checkbox"
                                id="flexCheckKannada"
                                style={{ transform: "scale(1)" }}
                              />
                              <label
                                htmlFor="flexCheckKannada"
                                className="text-secondary fs-12"
                              >
                                Kannada
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <button
                            className="btn btn-success w-100"
                            style={{
                              padding: "2px 6px",
                              borderRadius: "6px",
                            }}
                          >
                            View All Languages
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="property-item text-secondary ms-2 me-4 pe-4">
                    <div>
                      <label className="me-2 text-secondary mb-0 fs-13">
                        Properties
                      </label>
                      <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown3}
                        role="button"
                        aria-expanded={isDropdownVisible3}
                        style={{ cursor: "pointer" }} 
                      ></i>
                    </div>
                    {isDropdownVisible3 && isOpen && (
                      <div
                        className="mt-2"
                        
                        style={{ zIndex: 2000, minWidth: "180px" }}
                      >
                        <div className="fs-12 ">Answer Order:</div>
                        <div className="row g-1 mt-2">
                          <div className="col-6">
                            <div>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                style={{ transform: "scale(0.8)" }}
                              />
                              <label
                                className="form-check-label text-secondary fs-12 ms-1"
                                htmlFor="flexRadioDefault1"
                              >
                                Default
                              </label>
                            </div>
                            <div>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                style={{ transform: "scale(0.8)" }}
                              />
                              <label
                                className="form-check-label text-secondary fs-12 ms-1"
                                htmlFor="flexRadioDefault1"
                              >
                                Randomize
                              </label>
                            </div>
                          </div>
                          <div className="col-6">
                            <div>
                              <input
                                className="form-check-input"
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                style={{ transform: "scale(0.8)" }}
                              />
                              <label
                                className="form-check-label text-secondary fs-12 ms-1"
                                htmlFor="flexRadioDefault1"
                              >
                                Rotational
                              </label>
                            </div>
                            <div>
                              <input
                                className="form-check-input "
                                type="radio"
                                name="flexRadioDefault"
                                id="flexRadioDefault1"
                                style={{ transform: "scale(0.8)" }}
                              />
                              <label
                                className="form-check-label text-secondary fs-11 ms-1"
                                htmlFor="flexRadioDefault1"
                              >
                                Alphabetical
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex-column">
                    <div className="  pe-2 d-flex align-items-center text-secondary ms-1   me-2 fs-11">
                      Active
                      <div className="form-check form-switch ms-4 me-5 mt-3  ">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="flexSwitchCheckDefault"
                          checked
                        />
                      </div>
                    </div>

                    {isOpen && (
                      <div className="   d-flex align-items-center text-secondary  mb-4 pe-2 fs-11">
                        Hidden question
                        <div className="form-check form-switch ms-3 mt-2 ">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            checked={isChecked}
                            id="flexSwitchCheckDefault"
                            onChange={handleCheckboxChange}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className="arrow align-self-end"
                    onClick={toggleContent}
                    style={{
                      cursor: "pointer",
                    }}
                  >
                    <i
                      className={`bi ${isOpen ? "bi-chevron-down" : "bi-chevron-right"
                        }`}
                    ></i>
                  </div>
                </div>
                
              </div> */}
              <div className="section-2">
                <div className="text-secondary fw-bold mb-2">Question Properties</div>
                <div className={`question-properties d-flex justify-content-start  ${isOpen ? "expanded" : ""}`} style={{ flexGrow: 1, border: "none" }}>
                  {/* Column 1: Visibility Condition */}
                  <div className="col-lg-3 property-item text-secondary">
                    <div>
                      <label className="me-2 text-secondary mb-0 fs-13">Visibility condition</label>
                      {/* <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown}
                        role="button"
                        aria-expanded={isDropdownVisible}
                        style={{ cursor: "pointer" }}
                      ></i> */}
                      {isOpen && (
                        <i
                          className="bi bi-caret-down-fill text-secondary"
                          onClick={toggleDropdown}
                          role="button"
                          aria-expanded={isDropdownVisible}
                          style={{ cursor: "pointer" }}
                        ></i>
                      )}
                    </div>

                    <div style={{ zIndex: 2000 }}>
                      <div className="card pe-1 ps-1 fs-12 mt-2 w-75" style={{ border: "none", backgroundColor: "#e6ffe6" }}>
                        {isDropdownVisible && isOpen && <strong>Active Logic:</strong>}
                        (q1.val=r1 & q2.val=r5)
                      </div>
                      {isDropdownVisible && isOpen && (
                        <div className="mt-2">
                          <button className="btn btn-success w-100 mx-0" data-bs-toggle="modal" data-bs-target="#logicSetup">
                            Logic Setup
                          </button>
                        </div>
                      )}
                    </div>
                    <div className="modal fade" id="logicSetup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div className="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
                        <div className="modal-content p-2">
                          <div className="modal-header justify-content-between d-flex p-0 border-0">
                            <h1 className="modal-title text-black fw-bold fs-4 mt-2 px-3" id="exampleModalLabel">
                              Logic Condition Setup
                            </h1>
                            <span className="align-self-start fs-24 bg-danger-subtle rounded-circle" data-bs-dismiss="modal" aria-label="Close">
                              <i className="bi bi-x"></i>
                            </span>
                          </div>

                          <div className="modal-body">
                            {logicConditions.map((logic, index) => (
                              <div key={index}> <div className="row align-items-center my-3">
                                <div className="col-lg-1">

                                  <label className="form-label" htmlFor={`if-select-${index}`}>
                                    If
                                  </label>
                                </div>
                                <div className="col-lg-8">
                                  <select
                                    className="form-select text-center"
                                    id={`if-select-${index}`}
                                    value={logic.question}
                                    onChange={(e) => handleChange(index, 'question', e.target.value)}
                                  >
                                    <option value="">Select Question</option>
                                    {dummyquestions.map((question) => (
                                      <option key={question.id} value={question.text}>
                                        {question.text}
                                      </option>
                                    ))}
                                  </select>
                                </div>
                                <div className="col-lg-2">
                                  <select
                                    className="form-select text-center"
                                    id={`is-select-${index}`}
                                    value={logic.is}
                                    onChange={(e) => handleChange(index, 'is', e.target.value)}
                                  >
                                    <option value="=">Is</option>
                                    <option value="!=">Is not</option>
                                  </select>
                                </div>

                              </div>
                                <div className="row align-items-center">
                                  <div className="col-lg-1">
                                    <label className="form-label" htmlFor={`ans-select-${index}`}>
                                      Ans
                                    </label>
                                  </div>
                                  <div className="col-lg-8">
                                    <select
                                      className="form-select text-center"
                                      id={`ans-select-${index}`}
                                      value={logic.answer}
                                      onChange={(e) => handleChange(index, 'answer', e.target.value)}
                                    >
                                      <option value="">None selected</option>
                                      {dummyanswers.map((answer) => (
                                        <option key={answer.id} value={answer.text}>
                                          {answer.text}
                                        </option>
                                      ))}
                                    </select>
                                  </div>

                                </div>

                                {index < logicConditions.length - 1 && (<div className="d-flex align-items-center justify-content-center my-3">
                                  <hr className="flex-grow-1 " />
                                  <div className="d-flex align-items-center mx-2">
                                    <span className=" text-nowrap mx-2">Nest Question With</span>
                                    <select
                                      className="form-select form-select-sm"
                                      value={logic.nestlogic}
                                      onChange={(e) => handleChange(index, 'nestlogic', e.target.value)}
                                    >
                                      <option value="||">Or</option>
                                      <option value="&&">And</option>
                                    </select>
                                  </div>
                                  <hr className="flex-grow-1 " />
                                </div>)}
                              </div>
                            ))}



                            <div className="d-flex justify-content-center my-3">
                              <button className="btn btn-success" onClick={addLogicCondition}>
                                Add More Logic
                              </button>
                            </div>

                            <div className="form-control" onClick={toggleRowCodeVisibility}>
                              <label htmlFor="" className="form-label text-secondary">
                                Show Row Code
                              </label>
                              <i
                                className={`bi ${showRowCode ? "bi-caret-down-fill" : "bi-caret-right-fill"} text-secondary ms-1`}
                                style={{ cursor: "pointer" }}
                              ></i>
                            </div>
                            {showRowCode && (
                              <div>
                                <textarea name="" className="form-control h-25" id="" value={logicString}
                                  readOnly></textarea>
                              </div>
                            )}
                          </div>
                          <div className="d-flex justify-content-end">
                            <button className="btn btn-success" data-bs-dismiss="modal">
                              Save Logic
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Column 2: Language */}
                  <div className="col-lg-3 property-item text-secondary ms-2 me-2">
                    <div onClick={toggleDropdown2}>
                      <label className="me-2 text-secondary mb-0 fs-13">Language</label>
                      {isOpen && (
                        <i
                          className="bi bi-caret-down-fill text-secondary"
                          role="button"
                          aria-expanded={isDropdownVisible2}
                          style={{ cursor: "pointer" }}
                        ></i>
                      )}
                      {/* <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown2}
                        role="button"
                        aria-expanded={isDropdownVisible2}
                        style={{ cursor: "pointer" }}
                      ></i> */}
                    </div>

                    <div className="mt-2  px-2" style={{ minWidth: "140px", }}>
                      <div className="row g-1  position-relative " style={{ background: "#f8f9fe", zIndex: 999, }}>
                        {languages
                          .slice(0, showAllLanguages && isDropdownVisible2 && isOpen ? languages.length : defaultLanguagesToShow)
                          .map((language) => (<div className="col-6 d-flex align-items-center" key={language.id}>
                            <input id={language.id} className="form-check-input me-1" type="checkbox" style={{ transform: "scale(1)" }} />
                            <label htmlFor={language.id} className="text-secondary fs-12">
                              {language.label}
                            </label>
                          </div>))}
                        {/* <div className="col-6 d-flex align-items-center">
                          <input className="form-check-input me-1" type="checkbox" id="flexCheckHindi" style={{ transform: "scale(1)" }} />
                          <label htmlFor="flexCheckHindi" className="text-secondary fs-12">
                            Hindi
                          </label>
                        </div>
                        {isDropdownVisible2 && isOpen && (
                          <>
                            <div className="col-6 d-flex align-items-center">
                              <input className="form-check-input me-1" type="checkbox" id="flexCheckGerman" style={{ transform: "scale(1)" }} />
                              <label htmlFor="flexCheckGerman" className="text-secondary fs-12">
                                German
                              </label>
                            </div>

                            <div className="col-6 d-flex align-items-center">
                              <input className="form-check-input me-1" type="checkbox" id="flexCheckKannada" style={{ transform: "scale(1)" }} />
                              <label htmlFor="flexCheckKannada" className="text-secondary fs-12">
                                Kannada
                              </label>
                            </div> */}

                        {isDropdownVisible2 && isOpen && (<div className="mt-2 col-lg-12">
                          <button className="btn btn-success w-100" style={{ padding: "2px 6px", borderRadius: "6px" }} onClick={toggleShowAllLanguages}>
                            {showAllLanguages ? "Show Less" : "View All Languages"}
                          </button>
                        </div>

                        )}
                      </div>
                    </div>
                  </div>

                  {/* Column 3: Properties */}
                  <div className="col-lg-3 property-item text-secondary ms-2 me-2">
                    <div onClick={toggleDropdown3}>
                      <label className="me-2 text-secondary mb-0 fs-13">Properties</label>
                      {isOpen && (
                        <i
                          className="bi bi-caret-down-fill text-secondary"

                          role="button"
                          aria-expanded={isDropdownVisible3}
                          style={{ cursor: "pointer" }}
                        ></i>
                      )}
                      {/* <i
                        className="bi bi-caret-down-fill text-secondary"
                        onClick={toggleDropdown3}
                        role="button"
                        aria-expanded={isDropdownVisible3}
                        style={{ cursor: "pointer" }}
                      ></i> */}
                    </div>

                    <div className="mt-2" style={{ zIndex: 2000, minWidth: "180px" }}>
                      <div className="fs-12">Answer Order:</div>
                      {isDropdownVisible3 && isOpen && (
                        <div className="row g-1 mt-2">
                          <div className="col-6 d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              style={{ transform: "scale(0.8)" }}
                            />
                            <label className="form-check-label text-secondary fs-12 ms-1" htmlFor="flexRadioDefault1">
                              Default
                            </label>
                          </div>
                          <div className="col-6 d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              style={{ transform: "scale(0.8)" }}
                            />
                            <label className="form-check-label text-secondary fs-12 ms-1" htmlFor="flexRadioDefault1">
                              Randomize
                            </label>
                          </div>

                          <div className="col-6 d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              style={{ transform: "scale(0.8)" }}
                            />
                            <label className="form-check-label text-secondary fs-12 ms-1" htmlFor="flexRadioDefault1">
                              Rotational
                            </label>
                          </div>
                          <div className="col-6 d-flex align-items-center">
                            <input
                              className="form-check-input"
                              type="radio"
                              name="flexRadioDefault"
                              id="flexRadioDefault1"
                              style={{ transform: "scale(0.8)" }}
                            />
                            <label className="form-check-label text-secondary fs-12 ms-1" htmlFor="flexRadioDefault1">
                              Alphabetical
                            </label>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Column 4: Active/Hidden Question Switch */}
                  <div className="col-lg-2 flex-column">
                    <div className="pe-2 d-flex align-items-center text-secondary ms-1 me-2 fs-13 ">
                      Active
                      <div className="form-check form-switch ms-4 me-auto mt-2">
                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" checked />
                      </div>
                    </div>

                    <div className="d-flex align-items-center text-secondary  pe-2 fs-13">
                      Hidden question
                      <div className="form-check form-switch ms-3 mt-2">
                        <input className="form-check-input" type="checkbox" checked={isChecked} id="flexSwitchCheckDefault" onChange={handleCheckboxChange} />
                      </div>
                    </div>
                  </div>

                  {/* Arrow toggle */}
                  <div className="col-lg-1 align-self-end">

                    <div
                      className="arrow align-self-end"
                      onClick={toggleContent}
                      style={{
                        cursor: "pointer",
                      }}
                    >
                      <i className={`bi ${isOpen ? "bi-chevron-down" : "bi-chevron-right"}`}></i>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card p-3 border-light-subtle my-3">
                {/* <ul className="breadcrumb m-0 fs-20 gap-4">
                  <li>
                    <i className="bi bi-type-bold text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-type-italic text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-type-underline text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-type-strikethrough text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-link-45deg text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-list-ol text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-list-task text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-blockquote-left text-secondary"></i>
                  </li>
                  <li>
                    <i className="bi bi-code-slash text-secondary"></i>
                  </li>
                </ul> */}
                {toolbarElement}
              </div>
              {/* <div className="card p-3 border-light-subtle my-3">
                <div className="col-lg-6 form-group ms-2">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Placeholder question"
                  />
                </div>
              </div> */}
              <div className="card p-3 border-light-subtle my-3">
                <div className="d-flex align-items-center">
                  <div className="col-lg-8 form-group ms-2 ">{editableElements[0]}</div>
                  <div className="ms-2 d-flex align-items-center">
                    <button
                      title="Modify Question Style"
                      style={{
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        height: "33px",
                        width: "25px",
                      }}
                      data-bs-toggle="modal"
                      data-bs-target="#questionStyle"
                    >
                      <i className="bi bi-three-dots-vertical "></i>
                    </button>

                    <div className="modal fade" id="questionStyle" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                      <div className="modal-dialog">
                        <div className="modal-content p-2">
                          <div className="modal-header d-flex justify-content-between  p-0 border-0">
                            <h1 className="modal-title text-secondary fw-semibold fs-4 mt-4 px-3" id="exampleModalLabel">
                              Question Display Options
                            </h1>
                            <span className="align-self-start fs-24 bg-danger-subtle rounded-circle" data-bs-dismiss="modal" aria-label="Close">
                              <i className="bi bi-x"></i>
                            </span>
                          </div>
                          <div className="modal-body">
                            <div className="common_form ">
                              <div className="row">
                                <div className="col-lg-12">
                                  <div className="form-group mb-4">
                                    <label className="text-secondary fw-semibold" for="">
                                      Column Width
                                    </label>
                                    <select className="form-select text-secondary" name="" id="">
                                      <option value="20">20px</option>
                                      <option value="30">30px</option>
                                      <option value="40">40px</option>
                                      <option value="20">20px</option>
                                      <option value="20">20px</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-lg-12">
                                  <div className="form-group mb-4">
                                    <label className="text-secondary fw-semibold" for="">
                                      Row Width
                                    </label>
                                    <select className="form-select text-secondary" name="" id="">
                                      <option value="20">20px</option>
                                      <option value="30">30px</option>
                                      <option value="40">40px</option>
                                      <option value="20">20px</option>
                                      <option value="20">20px</option>
                                    </select>
                                  </div>
                                </div>

                                <div className="col-lg-6">
                                  <div className="form-group mb-4">
                                    <label className="text-secondary fw-semibold" for="">
                                      Column Break
                                    </label>
                                    <select className="form-select text-secondary" name="" id="">
                                      <option value="20">20</option>
                                      <option value="30">30</option>
                                      <option value="40">40</option>
                                      <option value="20">20</option>
                                      <option value="20">20</option>
                                    </select>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-group mb-4">
                                    <label className="text-secondary fw-semibold" for="">
                                      Prefix Label
                                    </label>
                                    <input type="text" className="form-control" placeholder="Text" />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="form-group ">
                                    <label className="text-secondary fw-semibold" for="">
                                      Postfix Label
                                    </label>
                                    <input type="text" className="form-control" placeholder="Text" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="modal-footer border-0">
                            <button type="button" className="btn bg-danger-subtle text-secondary fw-bold" data-bs-dismiss="modal">
                              Cancel
                            </button>
                            <button type="button" className="btn btn-success px-4" data-bs-dismiss="modal">
                              Save
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      className="ms-2"
                      style={{
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                        borderRadius: "5px",
                        height: "33px",
                        width: "25px",
                      }}
                    >
                      {/* <i className="bi bi-download "></i> */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-phone-flip " viewBox="0 0 16 16">
                        <path
                          fill-rule="evenodd"
                          d="M11 1H5a1 1 0 0 0-1 1v6a.5.5 0 0 1-1 0V2a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v6a.5.5 0 0 1-1 0V2a1 1 0 0 0-1-1m1 13a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-2a.5.5 0 0 0-1 0v2a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a.5.5 0 0 0-1 0zM1.713 7.954a.5.5 0 1 0-.419-.908c-.347.16-.654.348-.882.57C.184 7.842 0 8.139 0 8.5c0 .546.408.94.823 1.201.44.278 1.043.51 1.745.696C3.978 10.773 5.898 11 8 11q.148 0 .294-.002l-1.148 1.148a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 1 0-.708.708l1.145 1.144L8 10c-2.04 0-3.87-.221-5.174-.569-.656-.175-1.151-.374-1.47-.575C1.012 8.639 1 8.506 1 8.5c0-.003 0-.059.112-.17.115-.112.31-.242.6-.376Zm12.993-.908a.5.5 0 0 0-.419.908c.292.134.486.264.6.377.113.11.113.166.113.169s0 .065-.13.187c-.132.122-.352.26-.677.4-.645.28-1.596.523-2.763.687a.5.5 0 0 0 .14.99c1.212-.17 2.26-.43 3.02-.758.38-.164.713-.357.96-.587.246-.229.45-.537.45-.919 0-.362-.184-.66-.412-.883s-.535-.411-.882-.571M7.5 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
                <div>
                  <div >
                    <div className="col-lg-8 form-group ms-2 mt-3" onClick={toggleContentVisibility}>
                      Question Type
                      <i
                        className={`bi ${isContentVisible ? "bi-caret-down-fill" : " bi bi-caret-right-fill"} mx-1 text-secondary`}

                        style={{ cursor: "pointer" }}
                      ></i>
                    </div>
                    {isContentVisible && (
                      <div className="col-lg-12 form-group mt-3">
                        <ul className="nav nav-pills custom-nav-pills custom-background custom-navbar-height border rounded">
                          <li className="nav-item">
                            {/* <a
                              className="nav-link active"
                              aria-current="page"
                              href=""
                              style={{
                                fontSize: "12px",
                                borderRight: "1px solid gray",
                              }}
                            >
                              Single and Multi Select
                            </a> */}
                            <Link
                              className="nav-link active"
                              aria-current="page"
                              to="/survey-programming"
                              style={{
                                fontSize: "11px",
                                borderRight: "1px solid gray",
                              }}
                            >
                              Single and Multi Select
                            </Link>
                          </li>
                          <li className="nav-item">
                            {/* <a
                              className="nav-link"
                              href="#"
                              style={{ fontSize: "12px", borderRadius: "0" }}
                            >
                              Open End
                            </a> */}
                            <Link className="nav-link " to="/survey-programming" style={{ fontSize: "11px", borderRadius: "0" }}>
                              Open End
                            </Link>
                          </li>
                          <li className="nav-item">
                            {/* <a
                              className="nav-link"
                              href="#"
                              style={{ fontSize: "12px", borderRadius: "0" }}
                            >
                              Rate, Rank and Sort
                            </a> */}
                            <Link className="nav-link " to="/survey-programming" style={{ fontSize: "11px", borderRadius: "0" }}>
                              Rate, Rank and Sort
                            </Link>
                          </li>
                          <li className="nav-item">
                            {/* <a
                              className="nav-link"
                              style={{ fontSize: "12px", borderRadius: "0" }}
                            >
                              Stimulus
                            </a> */}
                            <Link className="nav-link " to="/survey-programming" style={{ fontSize: "11px", borderRadius: "0" }}>
                              Stimulus
                            </Link>
                          </li>
                          <li className="nav-item">
                            {/* <a
                              className="nav-link"
                              style={{ fontSize: "12px", borderRadius: "0" }}
                            >
                              Participant Upload
                            </a> */}
                            <Link className="nav-link " to="/survey-programming" style={{ fontSize: "11px", borderRadius: "0" }}>
                              Participant Upload
                            </Link>
                          </li>
                          <li className="nav-item">
                            {/* <a
                              className="nav-link"
                              style={{ fontSize: "12px" }}
                            >
                              Advanced
                            </a> */}
                            <Link className="nav-link " to="/survey-programming" style={{ fontSize: "11px", borderRadius: "0" }}>
                              Advanced
                            </Link>
                          </li>
                        </ul>
                        <div className="form-group d-flex mt-2 ms-n2 fs-12">
                          {[
                            {
                              icon: "bi-record-circle",
                              label: "Single Select",
                            },
                            { icon: "bi-caret-down-square", label: "Dropdown" },
                            { icon: "bi-check-square", label: "Multi-select" },
                            {
                              icon: "bi-grid-fill",
                              label: "Single select grid",
                            },
                            {
                              icon: "bi-grid-fill",
                              label: "Single select grid",
                            },
                            {
                              icon: "bi-grid-fill",
                              label: "Single select grid",
                            },
                          ].map((item, index) => (
                            <div
                              key={index}
                              className="card d-flex flex-column align-items-center me-1 width-15" // Apply the custom class here
                              onClick={() => handleCardClick(index)}
                              style={getCardStyle(index)}
                            >
                              <i className={`bi ${item.icon} fs-20 mb-1 mt-3`}></i>
                              <label className="mt-1 text-center">{item.label}</label>
                              <div className="d-flex align-items-center">
                                <i className="bi bi-info-circle me-1" data-bs-toggle="modal" data-bs-target="#questionDemo"></i>
                                <div className="d-flex bd-h-48 mx-1">
                                  <div className="vr me-1"></div>
                                </div>
                                <i className="bi bi-phone me-1"></i>
                                <i className="bi bi-tablet-landscape me-1"></i>
                                <i className="bi bi-laptop"></i>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal fade" id="questionDemo" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg">
                      <div className="modal-content p-2">
                        <div className="modal-header d-flex justify-content-end  p-0 border-0">
                          <span className="align-self-start fs-24 bg-danger-subtle rounded-circle" data-bs-dismiss="modal" aria-label="Close">
                            <i className="bi bi-x"></i>
                          </span>
                        </div>
                        <div className="modal-body p-4">
                          <div className="row">
                            <div className="col-lg-8 d-flex flex-column justify-content-between ">
                              <p>
                                Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eaque exercitationem eos, distinctio voluptatum explicabo est iure
                                ipsam non minus
                              </p>
                              <div>

                                <label htmlFor="">Optimized for</label>
                                <div className="d-flex gap-1">
                                  <i className="bi bi-check-circle-fill"></i>
                                  <i className="bi bi-phone me-1"></i>
                                  <i className="bi bi-tablet-landscape me-1"></i>
                                  <i className="bi bi-laptop"></i>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-4">
                              <div className="d-flex justify-content-between fw-bold mb-1">
                                <span>Learn More</span>
                                <Link to="/demo-questions">

                                  <span data-bs-dismiss="modal">
                                    <i className="bi bi-question-circle-fill mx-2"></i>Demo
                                  </span>
                                </Link>
                              </div>
                              <div>
                                <img src={process.env.PUBLIC_URL + "/Images/test.jpg"} alt="Question View" className="image-preview" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="col-lg-1 form-group d-flex mt-3">
                  <div className="card p-5 border-light-subtle me-2"></div>
                  <div className="card p-5 border-light-subtle me-2"></div>
                  <div className="card p-5 border-light-subtle me-2"></div>
                  <div className="card p-5 border-light-subtle me-2"></div>
                  <div className="card p-5 border-light-subtle me-2"></div>
                  <div className="card p-5 border-light-subtle me-2"></div>
                </div> */}
                  {/* <div className="form-group d-flex mt-2 ms-n2">
                  <div className="col-lg-2 card d-flex flex-column align-items-center me-1">
                    <i className="bi bi-record-circle fs-20 mb-1 mt-3"></i>
                    <label className="mt-1">Single Select</label>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-1"></i>
                      <div className="d-flex bd-h-48 mx-2">
                        <div className="vr me-1"></div>
                      </div>
                      <i className="bi bi-phone me-2"></i>
                      <i className="bi bi-tablet-landscape me-2"></i>
                      <i className="bi bi-laptop"></i>
                    </div>
                  </div>
                  <div className="col-lg-2 card d-flex flex-column align-items-center me-1">
                    <i className="bi bi-caret-down-square fs-20 mb-1 mt-3"></i>
                    <label htmlFor="" className="mt-1">
                      Dropdown
                    </label>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-1"></i>
                      <div className="d-flex bd-h-48 mx-2">
                        <div className="vr me-1"></div>
                      </div>
                      <i className="bi bi-phone me-2"></i>
                      <i className="bi bi-tablet-landscape me-2"></i>
                      <i className="bi bi-laptop"></i>
                    </div>
                  </div>
                  <div className="col-lg-2 card d-flex flex-column align-items-center me-1">
                    <i className="bi bi-check-square fs-20 mb-1 mt-3"></i>
                    <label htmlFor="" className="mt-1">
                      Multi-select
                    </label>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-1"></i>
                      <div className="d-flex bd-h-48 mx-2">
                        <div className="vr me-1"></div>
                      </div>
                      <i className="bi bi-phone me-2"></i>
                      <i className="bi bi-tablet-landscape me-2"></i>
                      <i className="bi bi-laptop"></i>
                    </div>
                  </div>
                  <div className="col-lg-2 card d-flex flex-column align-items-center me-1">
                    <i className="bi bi-grid-fill fs-20 mb-1 mt-3"></i>
                    <label htmlFor="" className="text-center">
                      Single select grid
                    </label>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-1"></i>
                      <div className="d-flex bd-h-48 mx-2">
                        <div className="vr me-1"></div>
                      </div>
                      <i className="bi bi-phone me-2"></i>
                      <i className="bi bi-tablet-landscape me-2"></i>
                      <i className="bi bi-laptop"></i>
                    </div>
                  </div>
                  <div className="col-lg-2 card d-flex flex-column align-items-center me-1">
                    <i className="bi bi-grid-fill fs-20 mb-1 mt-3"></i>
                    <label htmlFor="" className="text-center">
                      Single select grid
                    </label>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-1"></i>
                      <div className="d-flex bd-h-48 mx-2">
                        <div className="vr me-1"></div>
                      </div>
                      <i className="bi bi-phone me-2"></i>
                      <i className="bi bi-tablet-landscape me-2"></i>
                      <i className="bi bi-laptop"></i>
                    </div>
                  </div>
                  <div className="col-lg-2 card d-flex flex-column align-items-center me-1">
                    <i className="bi bi-record-circle fs-20 mb-1 mt-3"></i>
                    <label htmlFor="" className="text-center">
                      Single select grid
                    </label>
                    <div className="d-flex align-items-center">
                      <i className="bi bi-info-circle me-1"></i>
                      <div className="d-flex bd-h-48 mx-2">
                        <div className="vr me-1"></div>
                      </div>
                      <i className="bi bi-phone me-2"></i>
                      <i className="bi bi-tablet-landscape me-2"></i>
                      <i className="bi bi-laptop"></i>
                    </div>
                  </div>
                </div> */}
                  {/* <div className="form-group d-flex mt-2 ms-n2 fs-12">
                //     {[
                //       { icon: "bi-record-circle", label: "Single Select" },
                //       { icon: "bi-caret-down-square", label: "Dropdown" },
                //       { icon: "bi-check-square", label: "Multi-select" },
                //       { icon: "bi-grid-fill", label: "Single select grid" },
                //       { icon: "bi-grid-fill", label: "Single select grid" },
                //       { icon: "bi-grid-fill", label: "Single select grid" },
                //     ].map((item, index) => (
                //       <div
                //         key={index}
                //         className="card d-flex flex-column align-items-center me-1 width-15" // Apply the custom class here
                //         onClick={() => handleCardClick(index)}
                //         style={getCardStyle(index)}
                //       >
                //         <i className={`bi ${item.icon} fs-20 mb-1 mt-3`}></i>
                //         <label className="mt-1 text-center">{item.label}</label>
                //         <div className="d-flex align-items-center">
                //           <i className="bi bi-info-circle me-1"></i>
                //           <div className="d-flex bd-h-48 mx-1">
                //             <div className="vr me-1"></div>
                //           </div>
                //           <i className="bi bi-phone me-1"></i>
                //           <i className="bi bi-tablet-landscape me-1"></i>
                //           <i className="bi bi-laptop"></i>
                //         </div>
                //       </div>
                //     ))}
                //   </div>
                // </div> */}
                  <hr
                    className="my-3 "
                    style={{
                      borderTop: "1px solid #6c757d",
                    }}
                  />
                  <div>
                    <div className="col-lg-12 form-group ms-2 d-flex align-items-center" >
                      <span onClick={toggleVisibility}>Answer Rows</span>
                      <i
                        className={`bi ${isVisible ? "bi-caret-down-fill" : "bi-caret-right-fill"} text-secondary ms-2`}
                        onClick={toggleVisibility}
                        style={{ cursor: "pointer" }}
                      ></i>
                      {isVisible && (
                        <div className="ms-auto d-flex text-align-right dropdown">
                          <button
                            className="btn "
                            href="#"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              border: "1px solid #ccc",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              height: "35px",
                              width: "35px",
                            }}
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>

                          <button
                            className="btn btn-success ms-2"
                            style={{
                              border: "1px solid #ccc",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              height: "35px",
                              width: "100px",
                            }}
                            onClick={addRows}
                          >
                            Add row
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                Import Row
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Copy Row Option
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Delete Rows
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    {isVisible && (
                      <div>
                        <div className="d-flex align-items-center mt-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                            />
                          </svg>

                          <div className="form-group col-lg-4 ms-2">{editableElements[1]}</div>

                          {/* <div className="col-lg-1 ms-2">
                          {isVisible && (
                            <button
                              type="button"
                              className="btn btn-light p-0 border-0"
                              style={{
                                backgroundColor: "#FFE3E6",
                                width: "33px",
                              }}
                            // onClick={() => deleteAnswerRow(answer.id)} // Handle delete
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="red"
                                className="bi bi-trash3-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                              </svg>
                            </button>
                          )}
                        </div> */}
                        </div>
                        {renderRows()}
                      </div>
                    )}
                  </div>
                  <hr
                    className="my-3 "
                    style={{
                      borderTop: "1px solid #6c757d",
                    }}
                  />
                  <div>
                    <div className="col-lg-12 form-group ms-2 d-flex align-items-center">
                      <span onClick={toggleVisibility2}>Answer Columns</span>
                      <i
                        className={`bi ${isVisible2 ? "bi-caret-down-fill" : "bi-caret-right-fill"} text-secondary ms-2`}
                        onClick={toggleVisibility2}
                        style={{ cursor: "pointer" }}
                      ></i>
                      {isVisible2 && (
                        <div className="ms-auto d-flex text-align-right dropdown">
                          <button
                            className="btn "
                            href="#"
                            role="button"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            style={{
                              border: "1px solid #ccc",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              height: "35px",
                              width: "35px",
                            }}
                          >
                            <i className="bi bi-three-dots-vertical"></i>
                          </button>
                          <button
                            className="btn btn-success ms-2"
                            style={{
                              border: "1px solid #ccc",
                              backgroundColor: "#fff",
                              borderRadius: "5px",
                              height: "35px",
                            }}
                            onClick={addColumns} // Trigger the correct function for columns
                          >
                            Add Column
                          </button>
                          <ul className="dropdown-menu">
                            <li>
                              <a className="dropdown-item" href="#">
                                Import Column
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Copy Column Option
                              </a>
                            </li>
                            <li>
                              <a className="dropdown-item" href="#">
                                Delete Column
                              </a>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>

                    {isVisible2 && (
                      <div>
                        <div className="d-flex align-items-center mt-2">
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16">
                            <path
                              fill="currentColor"
                              fillRule="evenodd"
                              d="M7.375 3.67c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m0 8.66c0-.646-.56-1.17-1.25-1.17s-1.25.524-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17m-1.25-5.5c.69 0 1.25.525 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17s.56-1.17 1.25-1.17m5-3.16c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17c0 .646.56 1.17 1.25 1.17s1.25-.524 1.25-1.17m-1.25 7.49c.69 0 1.25.524 1.25 1.17s-.56 1.17-1.25 1.17s-1.25-.525-1.25-1.17c0-.646.56-1.17 1.25-1.17M11.125 8c0-.645-.56-1.17-1.25-1.17s-1.25.525-1.25 1.17s.56 1.17 1.25 1.17s1.25-.525 1.25-1.17"
                            />
                          </svg>

                          <div className="form-group col-lg-4 ms-2">{editableElements[2]}</div>
                        </div>
                        {renderColumns()}
                      </div>
                    )}
                  </div>
                  <hr
                    className="my-3 "
                    style={{
                      borderTop: "1px solid #6c757d",
                    }}
                  />
                  <div>
                    <div className="d-flex align-items-center" onClick={handleToggleInstructions}>
                      <label htmlFor=""> Instructions</label>
                      <i
                        className={`bi ${showInstructions ? "bi-caret-down-fill text-secondary" : "bi-caret-right-fill text-secondary"} mx-2`}
                        style={{ cursor: "pointer" }}

                      ></i>
                    </div>

                    {showInstructions && (
                      // <textarea
                      //   className="form-control mt-2 "
                      //   placeholder=""
                      //   rows="6"
                      //   style={{ height: "70px" }}
                      // ></textarea>
                      <>{editableElements[3]}</>
                    )}
                  </div>
                  <hr
                    className="my-3 "
                    style={{
                      borderTop: "1px solid #6c757d",
                    }}
                  />
                  <div>
                    <div className="d-flex align-items-center" onClick={handleToggleDescription}>
                      <label htmlFor="">Description</label>
                      <i
                        className={`bi ${showDescription ? "bi-caret-down-fill text-secondary" : "bi-caret-right-fill text-secondary"} mx-2`}
                        style={{ cursor: "pointer" }}

                      ></i>
                    </div>

                    {showDescription && (
                      // <textarea
                      //   className="form-control mt-2 "
                      //   placeholder=""
                      //   rows="6"
                      //   style={{ height: "70px" }}
                      // ></textarea>
                      <>{editableElements[4]}</>
                    )}
                  </div>
                  <hr
                    className="my-3 "
                    style={{
                      borderTop: "1px solid #6c757d",
                    }}
                  />
                  {/* <div>
                  <label htmlFor="">Programmer's Instructions</label>
                  <i className="bi bi-caret-right-fill mx-2"></i>
                </div> */}
                  <div>
                    <div className="d-flex align-items-center" onClick={handleToggleProgramInstructions}>
                      <label htmlFor="">Programmer's Instructions</label>
                      <i
                        className={`bi ${showProgramInstructions ? "bi-caret-down-fill text-secondary" : "bi-caret-right-fill text-secondary"} mx-2`}
                        style={{ cursor: "pointer" }}

                      ></i>
                    </div>

                    {showProgramInstructions && (
                      // <textarea
                      //   className="form-control mt-2 "
                      //   placeholder=""
                      //   rows="6"
                      //   style={{ height: "70px" }}
                      // ></textarea>
                      <>{editableElements[5]}</>
                    )}
                  </div>
                  <hr
                    className="my-3 "
                    style={{
                      borderTop: "1px solid #6c757d",
                    }}
                  />
                  <div>
                    <div>
                      <button className="btn btn-success">Save question settings</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div >
  );
};

export default SurveyProgramming;
